'use client';
import { faLongArrowDown, faLongArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button } from '@pickleballinc/react-ui';
import parse from 'html-react-parser';
import { useState } from 'react';

import { PlayerData } from '@/types/players.types';

type BioProps = {
  player: PlayerData | undefined;
  bio: string | undefined;
};

export const Bio = ({ player, bio }: BioProps) => {
  const [showMore, setShowMore] = useState(false);
  const isDeclined =
    player && player.biography && player?.biography?.[player.biography.length - 1]?.dateOfRejection;
  const isPendingApproval =
    player &&
    player.biography &&
    (player?.biography?.[player.biography.length - 1]?.totalApprovals ?? 0) < 2;

  return player && bio && bio.length > 10 ? (
    <div className='mt-16 w-full'>
      <div className='mb-6 inline-flex flex-wrap items-center gap-2 text-2xl font-bold text-gray-900'>
        About {player.firstName} {player.lastNameAndSuffix}
        {isPendingApproval && !isDeclined ? (
          <Badge label='Pending approval' size='md' variation='warning' />
        ) : null}
        {isDeclined ? <Badge label='Declined' size='md' variation='error' /> : null}
      </div>
      {bio.length ? (
        <div className='mb-6 text-gray-600'>
          {showMore ? (
            <>
              {bio.split(/\n/).map((line) => {
                return (
                  <div key={`uuid-${crypto.randomUUID()}`} className='mb-4'>
                    {parse(line)}
                  </div>
                );
              })}
            </>
          ) : (
            bio
              ?.substring(0, 2000)
              .split(/\n/)
              .map((line) => (
                <div key={`uuid-${crypto.randomUUID()}`} className='mb-4'>
                  {parse(line)}
                </div>
              ))
          )}
        </div>
      ) : null}
      {bio.length > 2000 && (
        <div className='mt-6 flex flex-col gap-3'>
          <Button
            variant='link'
            className='!justify-center'
            size='sm'
            onClick={() => {
              setShowMore(!showMore);
            }}
            suffixIcon={
              showMore ? (
                <FontAwesomeIcon icon={faLongArrowUp} />
              ) : (
                <FontAwesomeIcon icon={faLongArrowDown} />
              )
            }
          >
            {showMore ? 'Show less' : 'Show more'}
          </Button>
        </div>
      )}
    </div>
  ) : null;
};
